import axios from 'axios'

const state = {}

const actions = {
  addBankTransfer: async ({commit}, submitData) => {
    const url = `orders/${submitData.order_id}/add-bank-transfer`
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        console.log(response)
      }
    }
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bank.transfer.js